import AOClpCountdown from '../countdown';
import AOClpCleanSearch from '../clean_search';
import AOClpSaleSearch from '../sale_hero_with_search/sales/search-form';

export default function CleanSearchWithSalesTimer() {
  const initiate = () => {
    const countdown = AOClpCountdown();
    countdown.initiate();

    const block = document.querySelector('.js-ao-clp-clean-search-with-sales-timer');
    const isSalesSearch = block?.dataset.isSalesSearch === 'true';

    if (isSalesSearch) {
      const searchForm = AOClpSaleSearch();
      searchForm.initiate();
    } else {
      const cleanSearch = AOClpCleanSearch();
      cleanSearch.initiate({});
    }
  };

  return { initiate };
}
